import axios from 'axios';
import { BASE_URL } from '../../constants';

export const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'X-Api-Key': 'AIzaSyBeeSRqNP5UHKs3GrOeiIBvJ9SIbJmxY9M'
    }
})
